import { Input, Flex as WebFlex } from '@aloft/toolkit-sui';

import { useState } from 'react';

import { PDFOnly } from '../../../summary/components/PDFOnly.tsx';
import { Typography } from '../../../summary/components/Typography.tsx';
import { WebOnly } from '../../../summary/components/WebOnly.tsx';
import { SummarySection } from '../SummarySection.tsx';
import { SummaryTableHorizontal } from '../SummaryTableHorizontal.js';
import { TitleAndExportToggleLockup } from '../TitleAndExportToggleLockup.tsx';
import { Tkv2PairedCostSummaryInterfaceV2 } from '../types.ts';
import { adjustment } from '../utils/formatters/adjustment.ts';
import { calculations } from '../utils/formatters/calculations.ts';
import { PairedCostSettingsBreakdown } from './PairedCostSettingsBreakdown.tsx';
import { hasAdjustments } from './hasAdjustments.ts';

export const AdjustmentBreakdownQuality = (props: Tkv2PairedCostSummaryInterfaceV2) => {
  const commentaryProps = props.exportableCommentaries.quality;
  const [commentary, setCommentary] = useState(commentaryProps.commentary);

  if (!hasAdjustments(props.results, 'quality')) {
    return null;
  }
  return (
    <SummarySection>
      <TitleAndExportToggleLockup
        {...props}
        title="Quality Adjustment"
        id="isQualityCommentaryInExport"
        commentary={commentaryProps}
      />
      <Typography variant="body1">
        It costs more to build higher quality improvements. Therefore, the quality adjustment equals
        the difference in price/sf between the subject and the comparable. This is then multiplied
        by the GLA of the property with superior quality.
      </Typography>
      <PDFOnly>
        <Typography variant="body1">{commentaryProps.commentary}</Typography>
      </PDFOnly>
      <SummaryTableHorizontal
        {...props}
        compSequence={props.compSequence}
        summary={props}
        columns={[
          {
            header: 'Quality',
            type: 'feature',
            adjustmentType: 'quality',
            path: 'uadQuality',
          },
          {
            header: 'Dwelling Cost Quality Level',
            type: 'feature',
            adjustmentType: 'quality',
            path: 'dwellingCostQuality',
          },
          {
            header: 'Adjustment Calculation',
            type: 'adjustment',
            adjustmentType: 'quality',
            path: 'calculations',
            valueFormatter: calculations,
          },
          {
            header: 'Adjustment',
            type: 'adjustment',
            adjustmentType: 'quality',
            path: 'adjustment',
            textAlign: 'right',
            valueFormatter: adjustment,
            includeTooltip: true,
          },
        ]}
      />
      <PairedCostSettingsBreakdown {...props} type="quality" />
      <WebOnly>
        <WebFlex marginTop="1rem" width="40rem">
          <Input
            type="multiline"
            onChange={setCommentary}
            value={commentary}
            onClear={() => setCommentary('')}
            onBlur={() => commentaryProps.updateCommentary(commentary)}
            resize="both"
            label="Commentary"
            size="sm"
          />
        </WebFlex>
      </WebOnly>
    </SummarySection>
  );
};
